<template>

</template>

<script>
export default {
  name: "PrivacyPolicyPage"
}
</script>


